import ToastHighLighter from '@/lib/ToastHighLighter';

export const PaasNavigationCode = () => {
  const language = 'html';
  const codeString = `
  // PAAS-Navigation
  <div class="paas container">
    <nav class="navbar navbar-light navbar-expand-lg navbar-main">
      <div
        class="collapse navbar-collapse pb-3 pb-lg-0"
        id="navbarTogglerDemo03"
      >
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link active" href="#">
              First level 1
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">
              First level 2
            </a>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              data-bs-toggle="dropdown"
            >
              First level 3
            </a>
            <ul class="dropdown-menu">
              <li class="nav-item">
                <a class="dropdown-item" href="#">
                  Second level 1
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  Second level 2
                </a>
                <ul class="submenu dropdown-menu">
                  <li>
                    <a class="dropdown-item" href="">
                      Third level 1
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="">
                      Third level 2
                    </a>
                  </li>
                  <li class="nav-item dropdown">
                    <a
                      class="nav-link dropdown-toggle"
                      href=""
                      data-bs-toggle="dropdown"
                    >
                      Third level 3
                    </a>
                    <ul class="submenu dropdown-menu">
                      <li>
                        <a class="dropdown-item" href="">
                          Fourth level 1
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="">
                          Fourth level 2
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a class="dropdown-item" href="">
                      Second level 4
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="">
                      Second level 5
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a class="dropdown-item" href="#">
                  Dropdown item 3
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="#">
                  Dropdown item 4
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">
              First level 1
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">
              First level 2
            </a>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              data-bs-toggle="dropdown"
            >
              Dropdown right
            </a>
            <ul class="dropdown-menu dropdown-menu-right">
              <li>
                <a class="dropdown-item" href="#">
                  Dropdown item 1
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="#">
                  Dropdown item 2
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  Dropdown item 3
                </a>
                <ul class="submenu submenu-left dropdown-menu">
                  <li>
                    <a class="dropdown-item" href="">
                      Submenu item 1
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="">
                      Submenu item 2
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="">
                      Submenu item 3
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="">
                      Submenu item 4
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a class="dropdown-item" href="#">
                  Dropdown item 4
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <div class="d-lg-none">
          <form
            method="get"
            class="form-control-lg search-form"
            action="https://www.fhnw.ch/plattformen/dokumentation-webdienste/"
            data-search-form=""
          >
            <div class="search-box-wrapper">
              <label htmlFor="63ef28553013c" class="sr-only">
                Geben Sie Ihren Suchbegriff ein
              </label>
              <input
                type="text"
                class="field"
                name="s"
                id="63ef28553013c"
                aria-label="Geben Sie Ihren Suchbegriff ein"
                placeholder="Geben Sie Ihren Suchbegriff ein"
                data-search-input=""
                autoComplete="off"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 484.5 484.5"
                class="enter-icon"
                data-search-enter-icon="enter-icon"
              >
                <path d="M433.5 114.75v102H96.9l91.8-91.8-35.7-35.7-153 153 153 153 35.7-35.7-91.8-91.8h387.6v-153z"></path>
              </svg>
            </div>
          </form>
        </div>
      </div>
    </nav>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'accordion'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
